import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const loader = () => import(/* webpackChunkName: "4-feat-live-persona-card" */ './LivePersonaCardErrorBoundary');

export default lazyLoadOnRender({ loader });
